import { FC } from "react";
import { Redirect, useParams } from "react-router-dom";
import { ChevronIcon } from "shared/ui/icons";
import { parseRaffleId } from "../../model/raffleRoute";
import { useRaffleDetail } from "../../model/useRaffleDetail";
import { useRafflePageNavigation } from "../../model/useRaffleNavigation";
import { RaffleLayout } from "./RaffleLayout";

import styles from "./RaffleDetailPage.module.css";

const RaffleContent: FC<{ raffleId: number; inviteCode: string | null }> = ({
  raffleId,
  inviteCode,
}) => {
  const { raffle, isLoading, errorMessage } = useRaffleDetail(raffleId);

  if (isLoading) return <p className={styles.placeholder}>Loading...</p>;
  if (!raffle) return <p className={styles.placeholder}>{errorMessage}</p>;
  return <RaffleLayout raffle={raffle} inviteCode={inviteCode} />;
};

export const RaffleDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { inviteCode, goBack } = useRafflePageNavigation();
  const raffleId = parseRaffleId(id);

  if (raffleId === null) return <Redirect to="/dashboard" />;

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <button type="button" className={styles.back} onClick={goBack}>
          <ChevronIcon
            direction="left"
            width={12}
            height={6}
            fill="currentColor"
          />
          Back to promos
        </button>
        {/* key: при переходе на другой розыгрыш не показывать старые данные. */}
        <RaffleContent
          key={raffleId}
          raffleId={raffleId}
          inviteCode={inviteCode}
        />
      </div>
    </div>
  );
};
